import { createSlice } from '@reduxjs/toolkit';

export const shopifySettingsSlice = createSlice({
  name: 'shopifySettings',
  initialState: {
    shopifyStores: [],
    loading: false,
    error: null,
  },
  reducers: {
    setShopifyStores: (state, action) => {
      state.shopifyStores = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  }
});

export const {
  setShopifyStores,
  setLoading,
  setError
} = shopifySettingsSlice.actions;

export default shopifySettingsSlice.reducer;
